import { createSlice } from '@reduxjs/toolkit';

import { STORAGE_PREFIX } from '../../config';

import { SalerConfig } from '../types';

const KEY = `${STORAGE_PREFIX}salerConfig`;
const info = window.localStorage.getItem(KEY);

const slice = createSlice({
    name: 'salerConfig',
    initialState: info ? JSON.parse(info) : {},
    reducers: {
        updateSalerConfig(state, { payload }: { payload: SalerConfig }) {
            window.localStorage.setItem(KEY, JSON.stringify(payload));
            return payload;
        },
    },
});

export const { updateSalerConfig } = slice.actions;

export default slice.reducer;
